import {Component, EventEmitter, Input, OnInit, Output, ViewEncapsulation} from '@angular/core';
import {FormBuilder, FormGroup, ReactiveFormsModule, Validators} from '@angular/forms';
import {NgIf} from '@angular/common';
import {Category} from '../../../category/models/category.model';
// import {getCurrentDate} from '../../../../shared/utils/datetime.util';
import { getCurrentDate } from 'shared-frontend';
import { dateNotInPast, endDateAfterStartDate } from 'shared-frontend';
import {QuillEditorComponent} from '../../../../shared/components/quill-editor/quill-editor.component';

@Component({
  selector: 'app-event-form',
  standalone: true,
  imports: [
    ReactiveFormsModule,
    NgIf,
    QuillEditorComponent
  ],
  templateUrl: './event-form.component.html',
  styleUrl: './event-form.component.css'
  // encapsulation: ViewEncapsulation.None,
})
export class EventFormComponent implements OnInit {
  @Input() categories: Category[] = [];
  @Input() minDate: string = getCurrentDate();
  @Input() isCreateMode: boolean = false;
  @Output() formReady = new EventEmitter<FormGroup>();

  form!: FormGroup;

  constructor(private fb: FormBuilder) {}

  ngOnInit() {
    this.form = this.fb.group({
      eventTitle: ["", Validators.required],
      // eventCategoryId: ["", Validators.required],
      // eventDate: ["", [Validators.required, dateNotInPast()]],
      // eventTime: ["", Validators.required],
      // eventLocation: [""],
      // eventDescription: ["", Validators.required],
      // eventUrl: [""],
      // announcementStartDate: ["", Validators.required],
      // announcementEndDate: ["", [Validators.required, endDateAfterStartDate('announcementStartDate')]],
      // contactName: ["", Validators.required],
      // contactPhone: ["", Validators.required],
      // contactEmail: ["", Validators.required],
      // announcementSubmittedBy: ["", Validators.required],
      // announcementApprovalStatus: [""]
    });

    // Emit the form to the parent when it's ready (so each component doesn't try to populate the form before the form is ready
    this.formReady.emit(this.form);
  }
}
